import {memo, useContext} from "react";
import context from "../../../context/context";
import TabPanel from "../../UI/Tabs/TabPanel/TabPanel";
import RowMusicShelfList from "../../RowMusicShelf/RowMusicShelfList/RowMusicShelfList";

function NextSongsTab({
  selectedSong,
  list,
  isStaticList,
  setCurrentSongIndex,
  changeParam,
  index,
  value,
}) {
  const {reorderUpNext} = useContext(context);

  return (
    <TabPanel value={value} index={index}>
      <RowMusicShelfList
        selectedSong={selectedSong}
        isStaticList={isStaticList}
        changeSong={setCurrentSongIndex}
        changeParam={changeParam}
        list={list}
        onReorder={reorderUpNext}
      />
    </TabPanel>
  );
}

export default NextSongsTab;

